import React from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { ARTICLES, heroSrcSet } from "../mock";
import { ArticleCard } from "./Guide";
import { useReveal } from "../lib/lang";

const GuideArticle = () => {
  const { slug } = useParams();
  const a = ARTICLES.find((x) => x.slug === slug) || ARTICLES[0];
  const more = ARTICLES.filter((x) => x.slug !== a.slug).slice(0, 3);
  useReveal();
  return (
    <div data-testid="guide-article-page">
      <section className="relative h-[380px] overflow-hidden">
        <img src={a.image} srcSet={heroSrcSet(a.image)} sizes="100vw" alt={`${a.title} – Corfu travel guide by Aloha Corfu Transfers`} className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#183C35]/55" />
        <div className="relative h-full max-w-4xl mx-auto px-6 flex flex-col justify-end pb-12 fade-up">
          <Link to="/corfu-guide" className="flex items-center gap-2 text-[15px] text-[#F7F3EA]/85 hover:text-white transition-colors"><ArrowLeft className="w-4 h-4" />Corfu guide</Link>
          <p className="mt-3 text-[13px] tracking-[0.15em] uppercase text-[#E3CBA5]">{a.cat} · 2026-10-05</p>
          <h1 className="font-serif-d font-bold text-[38px] sm:text-[50px] text-[#F7F3EA] mt-2 leading-tight">{a.title}</h1>
        </div>
      </section>
      <article className="max-w-3xl mx-auto px-6 py-16">
        <p className="font-serif-d text-[22px] leading-relaxed text-[#183C35]">{a.excerpt}</p>
        {a.body.map((p, i) => <p key={i} className="mt-6 text-[17px] leading-[1.8] text-[#202522]/80">{p}</p>)}
        <div className="mt-12 rounded-2xl bg-[#1A3C37] p-8 text-[#F7F3EA]">
          <h3 className="font-serif-d text-[24px]">Need a ride while you're here?</h3>
          <p className="mt-2 text-[#F7F3EA]/80">Private, fixed-price transfers anywhere on the island.</p>
          <Link to="/book" className="mt-5 inline-flex items-center gap-2 rounded-full bg-[#E3CBA5] text-[#183C35] font-semibold px-6 py-3 hover:bg-[#EBD8B8] transition-colors">Book a transfer <ArrowRight className="w-4 h-4" /></Link>
        </div>
      </article>
      <section className="pb-12 sm:pb-24">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="font-serif-d text-[30px] text-[#183C35]">More from the guide</h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-8">{more.map((m) => <ArticleCard key={m.slug} a={m} />)}</div>
        </div>
      </section>
    </div>
  );
};

export default GuideArticle;
